import { render, staticRenderFns } from "./CommunityPublishersAdmin.vue?vue&type=template&id=5bac6ae0&scoped=true"
import script from "./CommunityPublishersAdmin.vue?vue&type=script&lang=js"
export * from "./CommunityPublishersAdmin.vue?vue&type=script&lang=js"
import style0 from "./CommunityPublishersAdmin.vue?vue&type=style&index=0&id=5bac6ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac6ae0",
  null
  
)

export default component.exports